/* MINIFLACONS · PDP Lab · Kern (Varianten, Warenkorb, Versand, Match, Sticky) */
(() => {
  'use strict';

  const FAM = ['frisch', 'fruchtig', 'blumig', 'holzig', 'ambriert', 'gourmand', 'rauchig'];
  const DRV = {
    Frisch: { frisch: 1 }, Zitrus: { frisch: 1 }, 'Grün': { frisch: .8 }, Aquatisch: { frisch: 1 },
    Fruchtig: { fruchtig: 1 }, Blumig: { blumig: 1 }, Pudrig: { blumig: .8 }, Holzig: { holzig: 1 },
    Erdig: { holzig: .8 }, Synthetisch: { holzig: .4, ambriert: .4 }, Orientalisch: { ambriert: 1 },
    Harzig: { ambriert: .7, rauchig: .3 }, 'Würzig': { ambriert: .4 }, 'Süß': { gourmand: .8 },
    Gourmand: { gourmand: 1 }, Cremig: { gourmand: .5 }, Rauchig: { rauchig: 1 }, Ledrig: { rauchig: 1 },
    Animalisch: { rauchig: .6 }, Chypre: { holzig: .6, blumig: .3 }, 'Fougère': { frisch: .5, holzig: .5 }
  };
  const POS = [3, 2.4, 1.9, 1.5, 1.2, 1, 1];

  const vec = dr => { const p = {}; (dr || []).forEach((d, k) => { const w = DRV[d]; if (w) for (const f in w) p[f] = (p[f] || 0) + w[f] * (POS[k] || 1); }); return p; };
  const cos = (a, b) => { let d = 0, na = 0, nb = 0; FAM.forEach(f => { const x = a[f] || 0, y = b[f] || 0; d += x * y; na += x * x; nb += y * y; }); return na && nb ? d / Math.sqrt(na * nb) : 0; };
  const classify = v => {
    const m = String(v.title || '').match(/(\d+(?:[.,]\d+)?)\s*ml/i);
    const ml = m ? parseFloat(m[1].replace(',', '.')) : 0;
    const ovp = /ovp/i.test(v.title);
    const kind = !ml ? 'other' : (ovp || ml > 10 ? 'flakon' : 'sample');
    return { ml, kind };
  };

  function makeMoney(fmt) {
    fmt = fmt || '€{{amount_with_comma_separator}}';
    const fix = (n, dec, th, ds) => { const p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); };
    return cents => {
      const n = (cents || 0) / 100;
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
        switch (k) {
          case 'amount': return fix(n, 2, ',', '.');
          case 'amount_no_decimals': return fix(n, 0, ',', '.');
          case 'amount_no_decimals_with_comma_separator': return fix(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fix(n, 2, "'", '.');
          default: return fix(n, 2, '.', ',');
        }
      }).replace(/<[^>]*>/g, '');
    };
  }

  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-mfl]').forEach(init);

  function init(root) {
    if (root.dataset.mflReady) return;
    root.dataset.mflReady = '1';

    let D;
    try { D = JSON.parse(root.querySelector('[data-mfl-json]').textContent); } catch (e) { console.warn('[MFL] data', e); return; }

    const $ = (s, el = root) => el.querySelector(s);
    const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
    const money = makeMoney(D.moneyFormat);
    D.variants.forEach(v => Object.assign(v, classify(v)));
    const byId = new Map(D.variants.map(v => [String(v.id), v]));

    const MFL = window.MFL = window.MFL || {};
    MFL.data = D; MFL.root = root; MFL.money = money; MFL.vec = vec; MFL.cos = cos; MFL.classify = classify; MFL.DRV = DRV; MFL.reduced = reduced;

    const form = $('[data-mfl-form]');
    const idInput = $('[data-mfl-id]');
    const atc = $('[data-mfl-atc]');
    const atcLabel = $('[data-mfl-atc-label]');
    const atcPrice = $('[data-mfl-atc-price]');
    const priceEl = $('[data-mfl-price]');
    const compareEl = $('[data-mfl-compare]');
    const errEl = $('[data-mfl-error]');
    const ship = $('[data-mfl-ship]');
    const stockEl = $('[data-mfl-stock]');
    const cutEl = $('[data-mfl-cutoff]');
    const mode = $('[data-mfl-mode]');
    const sticky = $('[data-mfl-sticky]');

    let cur = byId.get(String(D.selected)) || D.variants[0];
    const lastByKind = {};
    if (cur) lastByKind[cur.kind] = cur;

    /* ---------- Reichweite je Probengröße ---------- */
    const perDay = (D.cfg && D.cfg.spraysPerDay) || 3;
    $$('[data-mfl-days]').forEach(el => {
      const days = Math.round((+el.dataset.mflDays || 0) / perDay);
      let txt = '';
      if (days <= 10) txt = `≈ ${days} Tage`;
      else if (days < 28) txt = `≈ ${Math.round(days / 7)} Wochen`;
      else { const mo = Math.round(days / 30); txt = mo <= 1 ? '≈ 1 Monat' : `≈ ${mo} Monate`; }
      el.textContent = txt;
      el.title = `bei ${perDay} Sprühstößen pro Tag`;
    });

    /* ---------- Lieferstatus (Logik wie Live-Widget, inkl. delivery_override) ---------- */
    function stockState(v) {
      if (D.override === 'backorder') return 'backorder';
      if (D.override === 'soldout') return 'soldout';
      if (!v) return 'unknown';
      if (v.mgmt) {
        if (v.qty > 0) return 'available';
        if (v.policy === 'continue') return v.available ? 'backorder' : 'soldout';
        return v.available ? 'available' : 'soldout';
      }
      if (v.policy === 'continue') return v.available ? 'backorder' : 'soldout';
      return v.available ? 'available' : 'soldout';
    }
    const STOCK_TXT = {
      available: 'Auf Lager – innerhalb von 48 Stunden bei dir',
      backorder: 'In Zulieferung – in 3 bis 7 Tagen bei dir',
      soldout: 'Gerade vergriffen – trag dich unten ein',
      unknown: 'Verfügbarkeit wird geprüft …'
    };

    /* ---------- Versand-Countdown (Europe/Berlin, Mo–Fr) ---------- */
    const WD = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 0 };
    function berlin() {
      const parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hour12: false, weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        .formatToParts(new Date()).forEach(p => { parts[p.type] = p.value; });
      return { wd: WD[parts.weekday], h: (+parts.hour) % 24, m: +parts.minute, s: +parts.second };
    }
    function renderCutoff() {
      if (!cutEl) return;
      const state = stockState(cur);
      if (state !== 'available' || cur.kind === 'other') { cutEl.hidden = true; return; }
      const c = cur.kind === 'flakon' ? D.cfg.cutFlakon : D.cfg.cutSample;
      const t = berlin();
      const nowS = t.h * 3600 + t.m * 60 + t.s, cutS = c * 3600;
      const what = cur.kind === 'flakon' ? 'geht dein Flakon' : 'wird deine Probe';
      const verb = cur.kind === 'flakon' ? 'heute noch raus' : 'heute abgefüllt &amp; verschickt';
      let html;
      if (t.wd >= 1 && t.wd <= 5 && nowS < cutS) {
        const rest = cutS - nowS, h = Math.floor(rest / 3600), m = Math.floor((rest % 3600) / 60);
        const left = h ? `${h} Std. ${m} Min.` : `${Math.max(1, m)} Min.`;
        html = `Bestellst du in <b>${left}</b>, ${what} ${verb}.`;
      } else {
        const next = (t.wd === 5 || t.wd === 6 || t.wd === 0) ? 'am Montag' : 'morgen';
        html = cur.kind === 'flakon'
          ? `Jetzt bestellen – dein Flakon geht <b>${next}</b> raus.`
          : `Jetzt bestellen – deine Probe wird <b>${next}</b> abgefüllt &amp; verschickt.`;
      }
      cutEl.innerHTML = `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span>${html}</span>`;
      cutEl.hidden = false;
    }
    setInterval(renderCutoff, 20000);

    /* ---------- Variante wählen ---------- */
    function tick(el, html) {
      if (!el || el.innerHTML === html) return;
      el.innerHTML = html;
      if (reduced()) return;
      el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
    }
    function select(id, opts = {}) {
      const v = byId.get(String(id));
      if (!v) return;
      cur = v; lastByKind[v.kind] = v;
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));

      $$('[data-mfl-variant]').forEach(b => {
        const on = b.dataset.mflVariant === String(v.id);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      tick(priceEl, money(v.price));
      if (compareEl) { compareEl.hidden = !(v.compare > v.price); compareEl.textContent = money(v.compare); }
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      atcPrice.textContent = money(v.price);

      const st = stockState(v);
      ship.classList.remove('is-available', 'is-backorder', 'is-soldout');
      ship.classList.add('is-' + st);
      stockEl.textContent = STOCK_TXT[st] || STOCK_TXT.unknown;
      renderCutoff();

      if (sticky) {
        $('[data-mfl-sticky-size]').textContent = v.kind === 'flakon' ? `${v.title.replace(/\s*ovp/i, '')} · Originalflakon` : `${v.title} · Probe`;
        $('[data-mfl-sticky-price]').textContent = money(v.price);
        $('[data-mfl-sticky-label]').textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
        $('[data-mfl-sticky-btn]').disabled = !v.available;
      }

      if (!opts.silent) {
        try {
          const u = new URL(location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(history.state, '', u.toString());
        } catch (e) {}
      }
      MFL.current = v;
      document.dispatchEvent(new CustomEvent('mfl:variant', { detail: { variant: v, data: D } }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
    }
    MFL.select = select;

    root.addEventListener('click', e => {
      const b = e.target.closest('[data-mfl-variant]');
      if (b && root.contains(b)) { e.preventDefault(); select(b.dataset.mflVariant); }
    });

    /* Tastatur: Pfeile im Radiogroup */
    $$('[role="radiogroup"]').forEach(g => g.addEventListener('keydown', e => {
      if (!/Arrow(Left|Right|Up|Down)/.test(e.key)) return;
      const items = $$('[data-mfl-variant]', g); const i = items.findIndex(x => x.classList.contains('is-on'));
      const n = items[(i + (/Right|Down/.test(e.key) ? 1 : -1) + items.length) % items.length];
      if (n) { e.preventDefault(); n.focus(); select(n.dataset.mflVariant); }
    }));

    /* ---------- Modus Probe / Flakon ---------- */
    function setMode(kind) {
      if (!mode) return;
      mode.dataset.on = kind;
      $$('.mfl-mode__btn', mode).forEach(b => { const on = b.dataset.kind === kind; b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on); });
      $$('[data-mfl-sizes]').forEach(g => { g.hidden = g.dataset.mflSizes !== kind; });
      const list = D.variants.filter(v => v.kind === kind);
      const pick = lastByKind[kind] || list.find(v => v.available) || list[0];
      if (pick && pick.id !== cur.id) select(pick.id);
    }
    if (mode) {
      mode.dataset.on = cur.kind === 'flakon' ? 'flakon' : 'sample';
      mode.addEventListener('click', e => { const b = e.target.closest('.mfl-mode__btn'); if (b) setMode(b.dataset.kind); });
    }
    MFL.setMode = setMode;

    /* ---------- In den Warenkorb ---------- */
    async function addItems(items) {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items })
      });
      const j = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(j.description || j.message || 'Das hat nicht geklappt.');
      if (!window.MFCart) setTimeout(() => { location.href = '/cart'; }, 300);
      setTimeout(() => document.dispatchEvent(new CustomEvent('mfl:cart')), 1200);
      return j;
    }
    MFL.addItems = addItems;

    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!cur || !cur.available || atc.classList.contains('is-loading')) return;
      errEl.hidden = true;
      atc.classList.add('is-loading');
      try {
        await addItems([{ id: cur.id, quantity: 1 }]);
        atc.classList.remove('is-loading');
        atc.classList.add('is-done');
        atcLabel.textContent = 'Hinzugefügt ✓';
        setTimeout(() => { atc.classList.remove('is-done'); atcLabel.textContent = cur.available ? 'In den Warenkorb' : 'Ausverkauft'; }, 2200);
      } catch (err) {
        atc.classList.remove('is-loading');
        errEl.textContent = err.message; errEl.hidden = false;
      }
    });

    /* ---------- Sticky-Leiste ---------- */
    if (sticky) {
      const btn = $('[data-mfl-sticky-btn]');
      btn.addEventListener('click', () => {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
      const wrap = $('.mfl-atc-wrap');
      if ('IntersectionObserver' in window && wrap) {
        new IntersectionObserver(([en]) => {
          const show = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-show', show);
          sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
          btn.tabIndex = show ? 0 : -1;
        }).observe(wrap);
      }
    }

    select(cur.id, { silent: !/[?&]variant=/.test(location.search) });
  }
})();